export const getUserRole = () => {
  return localStorage.getItem("role");
};
export const getAdminData = () => {
  const admin = localStorage.getItem("admin");
  return admin ? JSON.parse(admin) : null;
};
